import React, { useState } from 'react';
import AnimatedSection from './AnimatedSection';
import './SharedStyles.css';
import './LegalDocumentation.css';

const LegalDocumentation = () => {
  const [viewMode, setViewMode] = useState('embed'); // 'embed' or 'download'
  const pdfPath = '/docs/business license.pdf';

  return (
    <AnimatedSection direction="scale" className="legal-section" delay={100} id="legal">
      <div className="section-content-wrapper">
        <h2 className="section-title">
          Legal part & <span className="title-accent">documentation</span>
        </h2>
        
        <div className="license-card">
          <div className="license-header">
            <div className="license-badge">
              <span className="badge-icon">📄</span>
              <span>Official License</span>
            </div>
            <h3 className="license-title">Business License</h3>
            <div className="license-actions">
              <button 
                className={`action-btn ${viewMode === 'embed' ? 'active' : ''}`}
                onClick={() => setViewMode('embed')}
              >
                View
              </button>
              <a 
                href={pdfPath} 
                download="business-license.pdf"
                className="action-btn download-btn"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </a>
            </div>
          </div>
          
          <div className="pdf-container">
            {viewMode === 'embed' && (
              <iframe
                src={`${pdfPath}#toolbar=0`}
                className="pdf-viewer"
                title="Business License"
                type="application/pdf"
              />
            )}
            <div className="pdf-fallback">
              <p className="fallback-text">
                If the PDF doesn't display, you can{' '}
                <a href={pdfPath} download="business-license.pdf" className="fallback-link">
                  download it here
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
};

export default LegalDocumentation;
